<template>
  <div>
    <unicom-cabecalho-v3
      :objetoPerfilProp="objetoPerfilComputed"
      :objetoUnimedProp="objetoUnimedComputed"
      :listaBotoes="listaBotoesComputed"
      :fotoPerfil="fotoPerfil"
      @home="redirecionarHome"
      @click-botoes="clickBotoes"
      abrirMenuClique
    >
      <div
        slot="depois-logo"
        style="display: flex; height: 42px; align-items: center"
      >
        <transition name="fade">
          <unicom-breadcrumb
            v-if="mostrarBread"
            contemHover
            :itens="breadcrumb"
          />
        </transition>
      </div>
    </unicom-cabecalho-v3>
    <unicom-navbar-v2
      nomeIconeExtra="search"
      :titulo="titulo"
      :itens="listaTelasFilter"
      tituloExtra="Buscar transação"
      caminhoHome="/home"
      :fecharMenuExtra="false"
    />
  </div>
</template>

<script>
// Mixins (Onde contém as funções e services)
import NavbarMixin from "./shared/mixins/NavbarMixin";
import HeaderMixin from "./shared/mixins/HeaderMixin";

export default {
  mixins: [NavbarMixin, HeaderMixin]
};
</script>
